import WarningCallout from "@/components/WarningCallout"
import { ReactComponent as BrowserIcon } from "@/icons/browser-icon.svg"
import { useState, useEffect } from "react"

const MobileWarningOverlay = () => {
  const [isDismissed, setIsDismissed] = useState(false)

  useEffect(() => {
    // Check if user has dismissed the overlay in this session
    const dismissed = sessionStorage.getItem("mobileWarningDismissed")
    if (dismissed === "true") {
      setIsDismissed(true)
    }
  }, [])

  const handleDismiss = () => {
    setIsDismissed(true)
    sessionStorage.setItem("mobileWarningDismissed", "true")
  }

  if (isDismissed) {
    return null
  }

  return (
    <section className="fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center bg-jaguar p-5 lg:hidden">
      <div className="relative mx-auto max-w-md space-y-4 px-7 text-silver">
        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="absolute -right-2 -top-2 flex h-8 w-8 items-center justify-center rounded-full bg-dark text-silver transition-colors hover:bg-gray-700 hover:text-white"
          aria-label="Dismiss warning"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <BrowserIcon className="mb-7 h-20 w-20" />
        <h1 className="type-body-xl font-bold">
          Sorry, smartphones are currently not supported by JDS Labs Core.
        </h1>
        <p>Please switch to a supported desktop browser:</p>
        <ul className="list-disc pl-5">
          <li>Google Chrome</li>
          <li>Microsoft Edge</li>
          <li>Opera</li>
          <li>Brave</li>
          <li>Firefox*</li>
        </ul>
        <p>
          *Firefox requires the{" "}
          <a
            href="https://addons.mozilla.org/en-US/firefox/addon/webserial-for-firefox/"
            className="text-red"
            target="_blank"
          >
            WebSerial for Firefox
          </a>{" "}
          extension.
        </p>
        <p className="mt-8">
          Note: Window must be at least 1024px wide and in landscape orientation for optimal
          rendering of the equalizer canvas.
        </p>

        <button
          onClick={handleDismiss}
          className="mt-6 w-full rounded-plus bg-red px-6 py-3 font-medium text-white transition-colors hover:bg-red/90"
        >
          🔓 Launch Anyway?
        </button>
      </div>
    </section>
  )
}

export default MobileWarningOverlay
